//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _changeHistory from './changeHistory';
import _deployment from './deployment';
import _page from './page';
import _profileMenu from './profileMenu';
import _update_metadata_namespace_success from './update_metadata_namespace_success';
import _useCaseDetail from './useCaseDetail';
import _utilities from './utilities';
import _willCreate_metadata_splashUseCaseDetail from './willCreate_metadata_splashUseCaseDetail';
import _willRemove_metadata_relation from './willRemove_metadata_relation';
import _willUpdate_metadata_relation from './willUpdate_metadata_relation';
export const changeHistory = _changeHistory;
export const deployment = _deployment;
export const page = _page;
export const profileMenu = _profileMenu;
export const update_metadata_namespace_success = _update_metadata_namespace_success;
export const useCaseDetail = _useCaseDetail;
export const utilities = _utilities;
export const willCreate_metadata_splashUseCaseDetail = _willCreate_metadata_splashUseCaseDetail;
export const willRemove_metadata_relation = _willRemove_metadata_relation;
export const willUpdate_metadata_relation = _willUpdate_metadata_relation;
export default {changeHistory, deployment, page, profileMenu, update_metadata_namespace_success, useCaseDetail, utilities, willCreate_metadata_splashUseCaseDetail, willRemove_metadata_relation, willUpdate_metadata_relation};

